import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { StyledExam } from './Styled'
import Header from './Header'
import InformationForm from './InformationForm'
import Confirmation from './Confirmation'
import ActionBar from './ActionBar'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { fetchCourseDetail } from './events'
import { useHistory } from 'react-router-dom'
import { StyledWrapper } from '../../components/Styled'
import Template from 'src/components/Template'

const GeneralEnroll = () => {
  const { id: uuid } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()

  const { enroll, activeStep, isInitialLoaded } = useSelector(
    (state) => ({
      enroll: state.eLearningEnroll.body.enroll,
      activeStep: state.eLearningEnroll.activeStep,
      isInitialLoaded: state.eLearningEnroll.isInitialLoaded,
    }),
    shallowEqual
  )

  useEffect(() => {
    dispatch(fetchCourseDetail(uuid))
  }, [])

  useEffect(() => {
    if (isInitialLoaded && activeStep === 0) {
      history.goBack()
    }
  }, [isInitialLoaded, activeStep])

  // ✅ เช็ก enroll ให้แน่ใจว่ามีข้อมูลก่อน render
  if (!isInitialLoaded || !Array.isArray(enroll) || enroll.length === 0) {
    return (
      <StyledWrapper>
        <Template maxWidth={1440}></Template>
      </StyledWrapper>
    )
  }

  return (
    <>
      <StyledExam>
        <Header />
        {activeStep === 1 && <InformationForm />}
        {activeStep === 2 && <Confirmation />}
      </StyledExam>
      <ActionBar />
    </>
  )
}

export default GeneralEnroll
